import Column from '@amzn/meridian/column';
import DateRangePicker from '@amzn/meridian/date-range-picker';
import Select, { SelectOption } from '@amzn/meridian/select';
import moment from 'moment-timezone';
import React, { FC, useMemo } from 'react';
import { DateFilterField } from '../../../redux/types';
import { TranslationFunction } from '../../blocks';

interface DateRangeFilterProps {
    value: string[];
    onChange: (values: string[]) => void;
    dateField: DateFilterField;
    onDateFieldChange: (field: DateFilterField) => void;
    t: TranslationFunction;
    timezone?: string;
}

const DateRangeFilter: FC<DateRangeFilterProps> = ({ value, onChange, dateField, onDateFieldChange, t, timezone }) => {
    const tz = timezone || 'UTC';
    const today = useMemo(() => moment.tz(tz).format('YYYY-MM-DD'), [tz]);
    const sevenDaysAgo = useMemo(() => moment.tz(tz).subtract(7, 'days').format('YYYY-MM-DD'), [tz]);
    const fourteenDaysAgo = useMemo(() => moment.tz(tz).subtract(14, 'days').format('YYYY-MM-DD'), [tz]);
    const thirtyDaysAgo = useMemo(() => moment.tz(tz).subtract(30, 'days').format('YYYY-MM-DD'), [tz]);

    return (
        <Column spacing={'small'}>
            <Select value={dateField} onChange={onDateFieldChange} size={'small'} data-testid={'dateFieldFilter'}>
                <SelectOption value={'creationDate'} label={t('creationDate-column')} />
                <SelectOption value={'requestedShipDate'} label={t('requestedShipDate-column')} />
                <SelectOption value={'requestedDeliveryDate'} label={t('requestedDeliveryDate-column')} />
            </Select>
            <DateRangePicker
                value={value}
                startId={'po-dateRangeStart'}
                endId={'po-dateRangeEnd'}
                startLabel={t('common:dateRangePicker-startPlaceholder')}
                endLabel={t('common:dateRangePicker-endPlaceholder')}
                allowSameStartAndEnd={true}
                onChange={onChange}
                monthsInView={1}
                clearButton={true}
                width={'25em'}
                presets={[
                    { label: t('last7Days-preset'), value: [sevenDaysAgo, today] },
                    { label: t('last14Days-preset'), value: [fourteenDaysAgo, today] },
                    { label: t('last30Days-preset'), value: [thirtyDaysAgo, today] },
                ]}
            />
        </Column>
    );
};

export default DateRangeFilter;
